import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import useMountedState from 'react-use/lib/useMountedState';
import { isLocalhostEnvironment } from '../utils/utils';
const UPDATE_INTERVAL_MS = 50;
// the larger the number, the smaller the change in displayed amount between updates
const AMOUNT_INCREASE_SLOWNESS_FACTOR = isLocalhostEnvironment() ? 2 : 5;
export const GrowingAmountDisplay = ({ amount: propsAmount }) => {
    // "cache" the initial amount and use that throughout the life of the component, ignoring subsequent prop changes that may come in:
    // (otherwise a prop change might mess with the animation)
    const [amount] = useState(propsAmount);
    const currAmountRef = useRef(0);
    const amountContainerRef = useRef(null);
    const isMounted = useMountedState();
    useEffect(() => {
        function updateAmount() {
            if (!isMounted()) {
                return;
            }
            currAmountRef.current += (amount - currAmountRef.current) / AMOUNT_INCREASE_SLOWNESS_FACTOR;
            if (!amountContainerRef.current) {
                return;
            }
            const roundedAmount = Math.round(currAmountRef.current);
            amountContainerRef.current.textContent = roundedAmount.toLocaleString();
            if (roundedAmount !== amount) {
                setTimeout(updateAmount, UPDATE_INTERVAL_MS);
            }
        }
        updateAmount();
    }, [amount, isMounted]);
    return _jsx("span", { ref: amountContainerRef });
};
